// import axios from "axios"
import axios from "../../constants/axios"
import React, { useState, useEffect, useContext } from "react"

import { Col, Row } from "react-bootstrap"

import {
  CANDIDATE_ADD_TO_CART,
  CANDIDATE_SHORTLIST,
} from "../company-profile/statistics/action/statisticsAction"

import Avatar from "../../images/wdn-avatar-placeholder.png"
import PictureSectionButtons from "./picture-section-buttons"
import { GlobalAuthContext } from "../../context/authContext"
import endpoints from "../../constants/endpoints"

const PictureSection = ({
  profile,
  cart,
  shortlist,
  contact,
  layoutType,
  username,
}) => {
  const [isInCart, setInCart] = useState(false) // eslint-disable-line no-unused-vars
  const [isShortlisted, setShortlist] = useState(false) // eslint-disable-line no-unused-vars
  const [isLoading, setLoading] = useState(false) // eslint-disable-line no-unused-vars
  const [cvLink, setCvLink] = useState() // eslint-disable-line no-unused-vars

  const { state } = useContext(GlobalAuthContext)
  const handleShortlist = () => {
    try {
      setLoading(true)
      const user = JSON.parse(localStorage.getItem("user"))
      CANDIDATE_SHORTLIST(
        user.company.id,
        profile.candidate.id,
        setLoading,
        setShortlist
      )
    } catch (err) {}
  }

  const handleAddToCart = () => {
    try {
      setLoading(true)
      const user = JSON.parse(localStorage.getItem("user"))
      CANDIDATE_ADD_TO_CART(
        user.company.id,
        profile.candidate.id,
        setLoading,
        setInCart
      )
    } catch (err) {}
  }

  const fileDownload = async () => {
    try {
      const res = await axios.get(
        process.env.GATSBY_BASE_URL + endpoints.CV_DOWNLOAD + username,
        {
          headers: {
            "Content-Type": "application/pdf",
          },
          responseType: "blob",
        }
      )

      let blob = new Blob([res.data], { type: "application/pdf" })
      let url = window.URL.createObjectURL(blob)
      setCvLink(url)
    } catch (error) {}
  }

  const renderDownload = () => {
    if (state?.user?.id === profile?.id) {
      return true
    } else if (
      state?.user?.role === 3 &&
      layoutType === 2 &&
      profile?.role !== "company" &&
      profile?.profile?.experience !== "Fresher"
    ) {
      return true
    }
    return false
  }

  useEffect(() => {
    if (!cvLink) {
      fileDownload()
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Col lg={"3"}>
      <div className="pic-and-info ">
        <Row className="align-items-center ">
          <Col lg={"12"}>
            <div className="pic-button-container text-center mb-4">
              <div className="pic-container">
                <img
                  src={
                    !!profile?.candidate?.thumbnail
                      ? profile?.candidate?.thumbnail
                      : profile?.avatar
                      ? profile?.avatar
                      : Avatar
                  }
                  alt={
                    profile?.first_name + "-" + profile?.last_name + "-avatar"
                  }
                />
              </div>

              <div>
                <div className="button-container text-center m-auto">
                  <PictureSectionButtons
                    profile={profile}
                    contact={contact}
                    cart={cart}
                    shortlist={shortlist}
                    handleAddToCart={handleAddToCart}
                    handleShortlist={handleShortlist}
                    isCandidate={state?.user?.candidate?.id}
                    isCompany={state?.user?.company?.id}
                  />
                </div>
                {renderDownload() && !!cvLink && (
                  <div className="download-btn-container">
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      download={profile?.first_name + "" + profile?.last_name}
                      href={cvLink}
                      className="btn btn-custom btn-small blue-background w-100 rounded"
                    >
                      Download CV
                    </a>
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </Col>
  )
}

export default PictureSection
